import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import {
  customizeVerticalScrollbarThumbMixin,
  setCommonBorderStyles
} from 'styles/mixins'

export const EditorWrapper = styled.div`
  position: relative;
  width: 100%;
`

// The non-animated placeholder reuses the typewriter's overlay so both line up
// with where real input appears.
export { Overlay as PlaceholderOverlay } from '../AnimatedPlaceholder/styled'

/**
 * Mirrors common-components/TextAreaInput's field styles so swapping the
 * textarea for this contenteditable is visually invisible. Chips are created
 * imperatively (the content is not React-rendered), so they are styled here
 * as nested classes rather than styled components.
 */
export const Editor = styled.div<{
  $minHeight?: number
  $maxHeight?: number
  $maxHeightMobile?: number
  $isError?: boolean
}>`
  padding: 12px;
  width: 100%;
  min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}px` : '105px')};
  max-height: ${({ $maxHeight }) => ($maxHeight ? `${$maxHeight}px` : 'none')};
  overflow-y: auto;

  ${({ $maxHeightMobile }) =>
    $maxHeightMobile &&
    css`
      @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
        max-height: ${$maxHeightMobile}px;
      }
    `}

  border-radius: 4px;
  background-color: ${COLORS.white};
  color: ${COLORS.secondarySemiDark};
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: pre-wrap;
  overflow-wrap: break-word;

  ${customizeVerticalScrollbarThumbMixin()}
  ${({ $isError }) => setCommonBorderStyles($isError, false)}

  &:focus {
    outline: none;
  }

  .${'mention-chip'} {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0 4px 0 8px;
    margin: 0 1px;
    border-radius: 10px;
    background: ${COLORS.primaryLight};
    color: ${COLORS.primaryDark};
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    vertical-align: baseline;
  }

  .${'mention-chip-remove'} {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: inherit;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;

    &:hover {
      background: ${COLORS.primarySemiLight};
    }
  }
`

/**
 * Zero-size element positioned at the caret (or the clicked chip); the portal
 * Flyout anchors to it. Because useRelativeCoords recomputes on anchor
 * IDENTITY (not position), the caller remounts this via `key` whenever the
 * caret moves.
 */
export const PickerAnchor = styled.div`
  position: absolute;
  width: 0;
  height: 0;
`
